<template>
  <div>
    <el-dialog :title="this.addRCFlag ? '添加人车' : '新增提单'" :visible.sync="addBillVisible" :close-on-click-modal="false"
      @close="addCancel" center width="75%">
      <el-form v-if="!addRCFlag" :inline="true" label-width="90px" ref="addBillForm" class="demo-form-inline"
        :model="addBillForm" :rules="rules">
        <el-form-item label="一级货主:" prop="primaryCustomerTaxId">
          <el-select clearable v-model="addBillForm.primaryCustomerTaxId" filterable placeholder="请选择" style="width:170px"
            size="mini">
            <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级货主:" prop="secondaryCustomerTaxId">
          <el-select clearable v-model="addBillForm.secondaryCustomerTaxId" filterable placeholder="请选择"
            style="width:170px" size="mini">
            <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="货权方:" prop="ownerCustomerTaxId">
          <el-select clearable v-model="addBillForm.ownerCustomerTaxId" filterable placeholder="请选择" style="width:170px" size="mini">
            <el-option
              v-for="(item, index) in customerData"
              :key="index"
              :label="item.custerName"
              :value="item.taxpayerNumber"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="有效期至:" prop="failureTime">
          <el-date-picker v-model="addBillForm.failureTime" type="datetime" placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss" size="mini">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="carHoldFalg" label="是否扣车:">
          <el-radio-group v-model="addBillForm.carHoldFalg" size="small">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="outBillNo" label="外部单号:">
          <el-input size="mini" v-model="addBillForm.outBillNo"></el-input>
        </el-form-item>
        <el-form-item prop="remark" label="备注:">
          <el-input type="textarea" v-model="addBillForm.remark" maxlength="50" :rows="1" style="width:400px;"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <p>人车信息 <el-button type="primary" @click="addSiji">新增</el-button>
        </p>
        <hr>
        <el-table max-height="300px" border bordersize="mini" size="mini" ref="tabref" :data="subTableData"
          style="width:100%" highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }">
          <el-table-column :show-overflow-tooltip="true" type="index" prop="date" width="55" label="序号"
            align="center"></el-table-column>
          <el-table-column prop="vhcNo" label="提货车号" width="270">
            <template slot="header">
              <div><span class="red">*</span>提货车号</div>
            </template>
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.vhcNo" placeholder="请输入提货车号"
                @blur="vhcInput(scope.row.vhcNo)"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="driverName" label="司机姓名" width="">
            <template slot="header">
              <div><span class="red">*</span>司机姓名</div>
            </template>
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.driverName" placeholder="请输入司机姓名"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="driverIdentityNo" label="司机身份证号">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.driverIdentityNo" placeholder="请输入司机身份证号"
                @blur="idInput(scope.row.driverIdentityNo)"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="driverMobile" label="联系电话">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.driverMobile" placeholder="请输入司机联系电话"
                @blur="phoneInput(scope.row.driverMobile)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-button type="text" @click="selectSiji(scope.row, scope.$index)">选择司机</el-button>
              <el-button type="text" @click="deleteTable(scope.row, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button type="" @click="addCancel">取消</el-button>
        <el-button type="primary" @click="addSubmit" :loading='addLoading'>确定</el-button>
      </div>
    </el-dialog>
    <select-siji v-if="selectSijiVisible" :table.sync="selectSijiVisible" @selectDriver="selectDriver"></select-siji>
  </div>
</template>

<script>
import {
  getRelationCustomer, // 字典客户
  addEmptyBillDriver, // 字典客户
  deleteEmptyBillDriver, // 字典客户
  operationEmptyBillDriverList, // 字典客户
  addEmptyBillMaster // 出库提单 新增（来源手动）
} from '@/api/wms-stock.js'
import SelectSiji from '../SelectSiji'

const vhsrule = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/
const idrule = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/
const phonerule = /^[1]([3-9])[0-9]{9}$/

export default {
  components: { SelectSiji },

  name: 'XinzengTidan',
  data() {
    return {
      addBillForm: {
        primaryCustomerTaxId: '',
        secondaryCustomerTaxId: '',
        // ownerCustomerTaxId: '',
        // ownerCustomerName: '',
        huoQuanFang: '',
        failureTime: '',
        carHoldFalg: '',
        outBillNo: '',
        remark: ''
      },
      customerData: [], // 货主数据
      rules: {
        primaryCustomerTaxId: [{ required: true, message: '请选择一级货主', trigger: 'change' }],
        secondaryCustomerTaxId: [{ required: true, message: '请选择二 级货主', trigger: 'change' }],
        failureTime: [{ required: true, message: '请选择有效期', trigger: 'change' }],
        carHoldFalg: [{ required: true, message: '请选择是否扣车', trigger: 'change' }],
        outBillNo: [{ required: true, message: '请输入外部单号', trigger: 'blur' }]
      },
      subTableData: [],
      addLoading: false,
      selectSijiVisible: false,
      TableIndex: 0,
      hasValidFlag: true
    }
  },
  props: {
    addBillVisible: {
      type: Boolean,
      default: false
    },

    rowBillId: {
      type: Number
    },
    RCList: {
      type: Array
    },
    addRCFlag: {
      type: Boolean,
      default: false
    },
  },
  watch: {

  },
  mounted() {
    this.subTableData = []
    console.log(this.RCList, 'this.RCList')
    if (this.RCList.length !== 0) {
      this.RCList.forEach((item, index) => {
        this.$set(item, 'billId', item.billId)
        this.$set(item, 'billNo', item.billNo)
        this.$set(item, 'billDriverId', item.billDriverId)
        this.$set(item, 'vhcNo', item.plateNumber)
        this.$set(item, 'driverName', item.driverName)
        this.$set(item, 'driverIdentityNo', item.idNumber)
        this.$set(item, 'driverMobile', item.telephone)
      })
      this.subTableData = this.RCList
    }else{
      this.addSiji()
    }
    this.getRelationCustomer()
    // this.addSiji()
  },
  methods: {
    addSiji() {
      let obj = {}
      obj.vhcNo = ''
      obj.billNo = ''
      obj.billDriverId = ''
      obj.driverName = ''
      obj.driverIdentityNo = ''
      obj.driverMobile = ''
      this.subTableData.push(obj)
    },
    addCancel() {
      this.$emit('update:addBillVisible', false)
    },
    addSubmit() {
      console.log(this.rowBillId, 'rowBillId')
      // 新增“添加人车”功能，车号和司机姓名为必填项
      if (this.addRCFlag) {


        this.addLoading = true
        let noValidate = this.subTableData.some(item => item.vhcNo == '')
        let driverNameValidate = this.subTableData.some(item => item.driverName == '')
        let chepai = this.subTableData.some(item => !vhsrule.test(item.vhcNo))
        let idCard = this.subTableData.some(item => !idrule.test(item.driverIdentityNo) && item.driverIdentityNo != '')
        let phoneCard = this.subTableData.some(item => !phonerule.test(item.driverMobile) && item.driverMobile != '')
        if (noValidate) {
          this.$message({ message: '提货车号不能为空', type: 'error' })
          this.addLoading = false
          return
        } else if (driverNameValidate) {
          this.$message({ message: '司机姓名不能为空', type: 'error' })
          this.addLoading = false
          return
        } else if (chepai) {
          this.$message({ message: '车牌号不正确', type: 'error' })
          this.addLoading = false
          return
        } else if (idCard) {
          this.$message({ message: '身份证号不正确', type: 'error' })
          this.addLoading = false
          return
        } else if (phoneCard) {
          this.$message({ message: '手机号不正确', type: 'error' })
          this.addLoading = false
          return
        }

        let plateNumber = ''; let driverName = ''; let telephone = ''; let idNumber = ''
        plateNumber = this.subTableData.map(item => item.vhcNo).join(',')
        // 司机姓名
        let driverNameArr = this.subTableData.map(item => item.driverName)
        driverNameArr.forEach((item, index) => {
          if (item == '') { driverNameArr.splice(index, 1) }
        })
        driverName = driverNameArr.join(',')
        // 司机联系电话
        let telephoneArr = this.subTableData.map(item => item.driverMobile)
        telephoneArr.forEach((item, index) => {
          if (item == '') { telephoneArr.splice(index, 1) }
        })
        telephone = telephoneArr.join(',')
        // 司机身份证
        let idNumberArr = this.subTableData.map(item => item.driverIdentityNo)
        idNumberArr.forEach((item, index) => {
          if (item == '') { idNumberArr.splice(index, 1) }
        })
        idNumber = idNumberArr.join(',')
        console.log(driverName, telephone, idNumber)
        this.subTableData.forEach((item, index) => {

          this.$set(item, 'plateNumber', item.vhcNo)
          this.$set(item, 'driverName', item.driverName)
          this.$set(item, 'idNumber', item.driverIdentityNo)
          this.$set(item, 'telephone', item.driverMobile)
        })

        operationEmptyBillDriverList(this.subTableData)
          .then(res => {
            console.log(res)
            this.addLoading = false
            this.$message({ message: '操作成功', type: 'success' })
            this.$emit('update:addBillVisible', false)
            this.$parent.getSeatchData()
          })
          .catch(err => {
            this.addLoading = false

            this.$message({ message: err.message, type: 'error' })
          })
      } else {
        this.$refs.addBillForm.validate((valid) => {
          if (valid) {
            this.addLoading = true
            let noValidate = this.subTableData.some(item => item.vhcNo == '')
            let driverNameValidate = this.subTableData.some(item => item.driverName == '')

            let chepai = this.subTableData.some(item => !vhsrule.test(item.vhcNo))
            let idCard = this.subTableData.some(item => !idrule.test(item.driverIdentityNo) && item.driverIdentityNo != '')
            let phoneCard = this.subTableData.some(item => !phonerule.test(item.driverMobile) && item.driverMobile != '')
            if (noValidate) {
              this.$message({ message: '提货车号不能为空', type: 'error' })
              this.addLoading = false
              return
            } else if (driverNameValidate) {
              this.$message({ message: '司机姓名不能为空', type: 'error' })
              this.addLoading = false
              return
            } else if (chepai) {
              this.$message({ message: '车牌号不正确', type: 'error' })
              this.addLoading = false
              return
            } else if (idCard) {
              this.$message({ message: '身份证号不正确', type: 'error' })
              this.addLoading = false
              return
            } else if (phoneCard) {
              this.$message({ message: '手机号不正确', type: 'error' })
              this.addLoading = false
              return
            }
            this.addBillForm.primaryCustomerName = this.customerData.filter(item => item.taxpayerNumber == this.addBillForm.primaryCustomerTaxId)[0].custerName
            this.addBillForm.secondaryCustomerName = this.customerData.filter(item => item.taxpayerNumber == this.addBillForm.secondaryCustomerTaxId)[0].custerName
            // this.customerData.forEach((item, index) => {
            //   if (item.taxpayerNumber == this.addBillForm.ownerCustomerTaxId) {
            //     this.addBillForm.ownerCustomerName = item.custerName
            //   }
            // })
            console.log(this.addBillForm, this.subTableData)
            let plateNumber = ''; let driverName = ''; let telephone = ''; let idNumber = ''
            plateNumber = this.subTableData.map(item => item.vhcNo).join(',')
            // 司机姓名
            let driverNameArr = this.subTableData.map(item => item.driverName)
            driverNameArr.forEach((item, index) => {
              if (item == '') { driverNameArr.splice(index, 1) }
            })
            driverName = driverNameArr.join(',')
            // 司机联系电话
            let telephoneArr = this.subTableData.map(item => item.driverMobile)
            telephoneArr.forEach((item, index) => {
              if (item == '') { telephoneArr.splice(index, 1) }
            })
            telephone = telephoneArr.join(',')
            // 司机身份证
            let idNumberArr = this.subTableData.map(item => item.driverIdentityNo)
            idNumberArr.forEach((item, index) => {
              if (item == '') { idNumberArr.splice(index, 1) }
            })
            idNumber = idNumberArr.join(',')
            console.log(driverName, telephone, idNumber)
            addEmptyBillMaster(
              {
                tEmptyBillMaster: { ...this.addBillForm, plateNumber, driverName, telephone, idNumber },
                carriageInfos: this.subTableData
              }
            )
              .then(res => {
                console.log(res)
                this.addLoading = false
                this.$emit('update:addBillVisible', false)
                this.$parent.getSeatchData()
              })
              .catch(err => {
                this.addLoading = false

                this.$message({ message: err.message, type: 'error' })
              })
          } else {
            this.addLoading = false
          }
        })
      }

    },
    selectSiji(row, index) {
      this.TableIndex = index
      this.selectSijiVisible = true
    },
    selectDriver(row) {
      console.log(row)
      this.$set(this.subTableData[this.TableIndex], 'driverName', row.name)
      this.$set(this.subTableData[this.TableIndex], 'driverMobile', row.mobile)
      this.$set(this.subTableData[this.TableIndex], 'driverIdentityNo', row.identityNo)
    },
    deleteTable(row, index) {
      if (row.billId) {
        deleteEmptyBillDriver({ billDriverId: row.billDriverId }).then(res => {
          this.subTableData.splice(index, 1)
        }).catch(err => {
          this.$message.error(err.message)
        })
      } else {
        this.subTableData.splice(index, 1)

      }
    },
    // 获取一级、二级客户
    getRelationCustomer() {
      getRelationCustomer().then(res => {
        this.customerData = res // 客户
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    vhcInput(val) {
      if (!vhsrule.test(val)) {
        this.$message({ message: '请输入正确的车牌号', type: 'error' })
      }
    },
    idInput(val) {
      if (val != '' && !idrule.test(val)) {
        this.$message({ message: '请输入正确的身份证号', type: 'error' })
      }
    },
    phoneInput(val) {
      if (val != '' && !phonerule.test(val)) {
        this.$message({ message: '请输入正确的手机号', type: 'error' })
      }
    }
  }
}
</script>

<style></style>
